import { Grid, Box } from '@aircall/tractor';
import { ModalForm } from '@components/ModalForm';
import { TextField } from '@components/TextField/TextField';
import {
  validateRequired,
  pipeValidators,
  validatePasswordLength,
  validatePasswordStrength,
  validateConfirmedPassword,
} from '@dashboard/library';
import { usePasswordUpdate } from '@hooks/usePasswordUpdate';
import { useTranslation } from 'react-i18next';

type OnModalHide = () => void;
export interface ChangePasswordModalProps {
  isModalOpen: boolean;
  onModalHide: OnModalHide;
}

export interface IChangePasswordFormValues {
  currentPassword: string;
  newPassword: string;
  confirmationPassword: string;
}

export function ChangePasswordModal({ isModalOpen, onModalHide }: ChangePasswordModalProps) {
  const { t } = useTranslation();
  const { onSubmit } = usePasswordUpdate({ onModalHide });

  return (
    <ModalForm<IChangePasswordFormValues>
      formProps={{ onSubmit }}
      show={isModalOpen}
      onHide={onModalHide}
      title={t('change_password.title')}
      submitButtonText={t('change_password.form.submit_button')}
    >
      {() => (
        <Grid gridTemplateColumns='1fr 1fr' pt='5' pr='5' pl='5' pb='6' gridGap='5'>
          <TextField
            name='currentPassword'
            label={t('change_password.form.current_password.label')}
            type='password'
            data-test='change_password.current_password'
            validate={validateRequired}
            size='regular'
          />
          <Box gridRow={2}>
            <TextField
              name='newPassword'
              label={t('change_password.form.new_password.label')}
              data-test='change_password.new_password'
              validate={pipeValidators(
                validateRequired,
                validatePasswordLength,
                validatePasswordStrength
              )}
              type='password'
              size='regular'
            />
          </Box>
          <Box gridRow={2}>
            <TextField
              name='confirmationPassword'
              label={t('change_password.form.confirm_password.label')}
              data-test='change_password.password_confirmation'
              validate={validateConfirmedPassword('newPassword')}
              type='password'
              size='regular'
            />
          </Box>
        </Grid>
      )}
    </ModalForm>
  );
}
